import {
    Environment,
    Label,
    DashboardProject,
    APP_NAME,
    DEFAULT_APP_ICON,
    Role,
    Group,
    GroupEnvironmentSummary
} from '@ffx/common';
import { DbProject } from '../interfaces/db-interfaces';

export type ProjectState = {
    environmentsInGroup: Environment[];
    labels: Label[];
    dashboardProjects: DashboardProject[];
    dashboardProjectsLoading: boolean;
    projectSettingsLoading: boolean;
    projectEnvironmentsLoading: boolean;
    groupEnvironmentsLoading: boolean;
    projectGroupsLoading: boolean;
    projectLabelsLoading: boolean;
    deleteProjectLoading: boolean;
    setupPageLoading: boolean;
    selectedProject: DbProject;
    selectedGroup: Group;
    selectedProjectRole: Role;
    errorMessage: string;
    allGroupsAndEnvironmentsSummary: GroupEnvironmentSummary[];
};

export const initialState: ProjectState = {
    dashboardProjects: [],
    dashboardProjectsLoading: true,
    deleteProjectLoading: false,

    environmentsInGroup: [],
    labels: [],
    projectSettingsLoading: false,
    projectEnvironmentsLoading: false,
    projectLabelsLoading: false,
    projectGroupsLoading: false,
    groupEnvironmentsLoading: false,
    setupPageLoading: false,

    selectedProjectRole: 'None',
    selectedProject: {
        id: '',
        name: APP_NAME,
        icon: DEFAULT_APP_ICON,
        labels: [],
        groups: []
    },
    selectedGroup: {
        id: '',
        name: '',
        cssColour: ''
    },
    errorMessage: '',
    allGroupsAndEnvironmentsSummary: []
};
